import { MANAGE_EXTRA_ACTIVITY_MODES } from 'common/activeElements/modals/ManageExtraActivity/const';
import { CREATABLE_EXTRA_ACTIVITY_OPTIONS } from 'common/ActivityChip/utils/extraActivities';
import {
	EXTRA_ACTIVITY_TIMELINE_SIDES,
	getTimelineExtraActivityOptions,
} from 'common/ExtraActivityTimelineManagement/rules';

export const ACTION_MENU_DEFAULT_POSITION = 'bottom';
export const ACTION_MENU_DEFAULT_ALIGNMENT = 'end';
export const ACTION_MENU_ALLOWED_POSITIONS = ['top', 'bottom'];

export const getActionMenuPosition = (smartPosition) =>
	ACTION_MENU_ALLOWED_POSITIONS.includes(smartPosition)
		? smartPosition
		: ACTION_MENU_DEFAULT_POSITION;

export const getAddExtraActivityPayload = ({
	activityType,
	availableActivityOptions,
	locations,
	rideId,
	sequenceGroupId,
}) => {
	const payload = {
		mode: MANAGE_EXTRA_ACTIVITY_MODES.add,
		selectedExtraActivity: activityType,
		locations,
		initialData: {
			rideId,
			sequenceGroupId,
		},
	};

	if (availableActivityOptions) {
		payload.availableActivityOptions = availableActivityOptions;
	}

	return payload;
};

export const getManageExtraActivityPayload = ({ item, locations }) => ({
	mode: MANAGE_EXTRA_ACTIVITY_MODES.manage,
	selectedExtraActivity: item.activityType,
	locations,
	initialData: {
		workAssignmentKey: {
			id: item.id,
			version: item.version,
		},
		stationId: item.stationId,
		activityType: item.activityType,
		durationMinutes: item.durationMinutes,
	},
});

export const getDeleteExtraActivityPayload = (item) => ({
	initialData: {
		workAssignmentKey: {
			id: item.id,
			version: item.version,
		},
	},
});

export const getCreatableExtraActivityOptions = ({ assignment = {}, locations = [], rideId }) => {
	const firstLocation = locations[0];
	const lastLocation = locations[locations.length - 1];
	const record = {
		activity: {
			activityType: assignment.activityType,
			rideId: assignment.rideId ?? rideId,
			sequenceGroupId: assignment.sequenceGroupId,
			fromStation: firstLocation,
			toStation: lastLocation,
			extraActivities: assignment.extraActivities ?? [],
		},
	};
	const allowedTypes = new Set(
		[
			...getTimelineExtraActivityOptions(record, EXTRA_ACTIVITY_TIMELINE_SIDES.before),
			...getTimelineExtraActivityOptions(record, EXTRA_ACTIVITY_TIMELINE_SIDES.after),
		].map(({ type }) => type)
	);

	return CREATABLE_EXTRA_ACTIVITY_OPTIONS.filter(({ type }) => allowedTypes.has(type));
};

export const getExtraActivityRows = (stacks = []) => {
	const allItems = stacks.flatMap((stack) =>
		stack.items.map((item) => ({
			...item,
			laneKey: stack.laneKey,
			placement: stack.placement,
		}))
	);

	const rows = [];
	const itemRowMap = new Map();

	allItems.forEach((item) => {
		const { placement, id } = item;

		const availableRow = rows.findIndex((occupiedColumns) => {
			for (let col = placement.from; col < placement.to; col++) {
				if (occupiedColumns.has(col)) return false;
			}
			return true;
		});

		const rowIndex = availableRow !== -1 ? availableRow : rows.length;

		if (rowIndex === rows.length) {
			rows.push(new Set());
		}

		for (let col = placement.from; col < placement.to; col++) {
			rows[rowIndex].add(col);
		}

		itemRowMap.set(id, rowIndex + 1);
	});

	return { itemRowMap, totalRows: rows.length };
};
